module.exports = __webpack_public_path__ + "static/media/nft1MOBILE.fd890908.jpg";